import classnames from "classnames";
import Loader from "react-feather/dist/icons/loader";

import style from "./style.module.scss";
import type { SpinnerProps } from "../../types";

function Spinner({ className }: SpinnerProps) {
  return (
    <div className={classnames(className, style.spinner)}>
      <Loader />
    </div>
  );
}

export default Spinner;
